module.exports = __webpack_public_path__ + "static/media/ic205renew.38171e8b.jpg";